import Modal from 'antd/es/modal';
import type { ReactNode } from 'react';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

import { userManagementSharedT as translations } from './translations';

type Props = {
  open: boolean;
  title: string;
  message: ReactNode;
  testId: string;
  onClose: () => void;
};

export const FeedbackModal = ({
  open,
  title,
  message,
  testId,
  onClose
}: Props) => {
  return (
    <Modal
      open={open}
      title={<div className="text-lg font-medium">{title}</div>}
      onCancel={onClose}
      closable={true}
      maskClosable={true}
      data-testid={testId}
      centered
      footer={
        <div className="flex justify-end">
          <PrimaryButton className="h-[36px] px-4" onClick={onClose}>
            {translations.common.actions.close}
          </PrimaryButton>
        </div>
      }
    >
      <div className="px-1 py-2 text-sm">{message}</div>
    </Modal>
  );
};
